import { PostDetailPage } from '~/src/components/post/DetailPage'

export default PostDetailPage